import { DEFAULT_EINVOICE_ADDRESS_SCHEME_TYPE } from '@components'

import { XRechnungEInvoicingAddressForm } from '../../../types/xRechnungEInvoicingAddressForm'

export const getXRechnungEInvoicingAddressFormDefaultValues = (): XRechnungEInvoicingAddressForm => {
  return {
    ean: '',
    eInvoiceScheme: DEFAULT_EINVOICE_ADDRESS_SCHEME_TYPE,
    publicEntityRoutingEnabled: false,
  }
}
